export default "__VITE_ASSET__5aad4f50__"